import parsePhoneNumber from 'libphonenumber-js';
import { CustomErrorParams } from 'zod';
import { COUNTRY_MOBILE_CODES } from './constants';

export class Validators {
  static keycloakName: [(_: string) => boolean, CustomErrorParams] = [
    (value: string) => {
      if (value === '' || value === null || value === undefined) return true;

      return /^[^<>&"\v$%!#?§;*~|^=\\/[\]{}()]+$/.test(value);
    },
    {
      params: {
        i18n: {
          key: 'customErrors.keycloakName',
        },
      },
    },
  ];

  static fullMobileNumber: [(_: string) => boolean, CustomErrorParams] = [
    (value: string) => {
      return /^\+?[1-9]\d{1,14}$/.test(value);
    },
    {
      params: {
        i18n: {
          key: 'customErrors.fullMobileNumber',
        },
      },
    },
  ];

  static stringIsNumber: [(_: string) => boolean, CustomErrorParams] = [
    (value: string) => {
      return /^\d+$/.test(value);
    },
    {
      params: {
        i18n: {
          key: 'customErrors.stringIsNumber',
        },
      },
    },
  ];

  static validatePhoneWithCountry = (countryIso2Field: string, localNumberField: string) => ({
    validator: (data: Record<string, unknown>) => {
      // Get the country code for the selected country
      const countryIso2 = data[countryIso2Field] as string;
      const localNumber = data[localNumberField] as string;

      const country = COUNTRY_MOBILE_CODES.find((code) => code.countryIso2 === countryIso2);
      if (!country) return false;

      // Create the full phone number
      const fullNumber = `${country.mobileCode}${localNumber}`;

      // Validate using the phone library
      const phoneData = parsePhoneNumber(fullNumber);
      return phoneData && phoneData.isValid();
    },
    params: {
      i18n: {
        key: 'customErrors.invalidMobileNumber',
      },
    },
    path: [localNumberField],
  });
}
